import { BeachIcon } from "~/components/Icon/Icons/Passions/BeachIcon";
import { CultureIcon } from "~/components/Icon/Icons/Passions/CultureIcon";
import { CulinaryIcon } from "~/components/Icon/Icons/Passions/CulinaryIcon";
import { GolfIcon } from "~/components/Icon/Icons/Passions/GolfIcon";
import { MusicIcon } from "~/components/Icon/Icons/Passions/MusicIcon";
import { SkiIcon } from "~/components/Icon/Icons/Passions/SkiIcon";
import { SpaIcon } from "~/components/Icon/Icons/Passions/SpaIcon";
import { BeverageIcon } from "~/components/Icon/Icons/Passions/BeverageIcon";
import { SurfIcon } from "~/components/Icon/Icons/Passions/SurfIcon";
import { BikeIcon } from "~/components/Icon/Icons/Passions/BikeIcon";
import { PaddleIcon } from "~/components/Icon/Icons/Passions/PaddleIcon";
import { FishIcon } from "~/components/Icon/Icons/Passions/FishIcon";
import { SafariIcon } from "~/components/Icon/Icons/Passions/SafariIcon";
import { DiveIcon } from "~/components/Icon/Icons/Passions/DiveIcon";
import { HikeIcon } from "~/components/Icon/Icons/Passions/HikeIcon";

export const passionsIcons = {
  beach: BeachIcon,
  culture: CultureIcon,
  culinary: CulinaryIcon,
  golf: GolfIcon,
  music: MusicIcon,
  ski: SkiIcon,
  spa: SpaIcon,
  paddle: PaddleIcon,
  bike: BikeIcon,
  fish: FishIcon,
  dive: DiveIcon,
  safari: SafariIcon,
  surf: SurfIcon,
  hike: HikeIcon,
  "am-drinks": BeverageIcon,
  "afternoon-drinks": BeverageIcon,
  "evening-drinks": BeverageIcon,
};
